import { RESCHEDULE_SOURCE } from "../../navigation/params";
import { actionTypes, setRescheduleSourceAction } from "./rescheduleSource.actions";

export interface IRescheduleSource {
  sourcePage: string;
}

const initialState: IRescheduleSource = {
  sourcePage: RESCHEDULE_SOURCE.DASHBOARD,
};

type RescheduleSourceActions = ReturnType<typeof setRescheduleSourceAction>;

export const rescheduleSourceReducer = (
  state: IRescheduleSource = initialState,
  action: RescheduleSourceActions,
): IRescheduleSource => {
  switch (action.type) {
  case actionTypes.SET_SOURCE:
    return {
      ...state,
      sourcePage: action.payload.sourcePage,
    };
  default:
    return state;
  }
};
